import Subjects from './Subjects';

export default Subjects;
